import { ISupportedLanguage } from '../model/language.model';

export const DEFAULT_LANGUAGE_CODE = 'en';

export const APP_LANGUAGES: ISupportedLanguage[] = [
  {
    countryCode: 'cs',
    language: 'Česky',
  },
  {
    countryCode: 'en',
    language: 'English',
  },
  {
    countryCode: 'sk',
    language: 'Slovensky',
  },
  {
    countryCode: 'uk',
    language: 'Ukrayinsʹkyy',
  },
  {
    countryCode: 'fr',
    language: 'Français',
  },
];
